import { render } from "./navigation-tiers.vue?vue&type=template&id=b9743942"
import script from "./navigation-tiers.vue?vue&type=script&lang=js"
export * from "./navigation-tiers.vue?vue&type=script&lang=js"

import "./navigation-tiers.vue?vue&type=style&index=0&id=b9743942&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__